import React, { useCallback, useLayoutEffect } from 'react';
import Animated from 'react-native-reanimated';
import Text from 'design-system/Text';
import Button, { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import { AppView, rem, Spacer } from 'design-system';
import { SCROLL_INDICATOR_INSETS } from 'design-system/values';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useMarginBottom } from 'hooks/useMarginBottom';
import createStyleSheets from 'utils/createStyleSheets';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { performanceExample } from '../constants';
import { isWeb } from '../../../constants';
import InvestPerformanceCard from '../components/InvestPerformanceCard';
const PerformanceExampleScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    const handleClose = useCallback(() => {
        navigation.goBack();
    }, []);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    return (<AppView type="secondary" withFrame={false}>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} contentContainerStyle={contentContainerStyle} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          <Text Text-24 style={styles.text}>
            {performanceExample.title}
          </Text>
          <InvestPerformanceCard variant="short"/>
          <Spacer h={16}/>
          <Text Text-16 style={styles.text}>
            What this graph shows
          </Text>
          <Text TextThin-16 Secondary style={styles.text}>
            {performanceExample.graphDisclaimer}
          </Text>
          <Spacer h={8}/>
          <Text Text-16 style={styles.text}>
            About this comparison
          </Text>
          {performanceExample.aboutParagraphs.map((paragraph, index) => (<Text key={index} TextThin-16 Secondary style={styles.paragraph}>
              {paragraph}
            </Text>))}
        </Animated.ScrollView>
        <Button brandReversed floating title="Close" onPress={handleClose} style={styles.button}/>
      </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default PerformanceExampleScreen;
const styleSet = createStyleSheets(() => ({
    text: {
        paddingHorizontal: rem(16),
        marginBottom: rem(16),
    },
    paragraph: {
        paddingHorizontal: rem(16),
        marginBottom: rem(8),
    },
    button: {
        marginHorizontal: rem(16),
    },
}));
